import { makeStyles } from '@material-ui/core';
import { calculateHeight, rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

interface OrderItemStyleProps {
  index: number;
}

export const styles = makeStyles(theme => ({
  resultsItem: {
    height: calculateHeight(60).stringValue,
    border: `1px solid ${themeColor.secondaryLight}`,
    padding: '0 1.02vw',
    marginTop: ({ index }: OrderItemStyleProps) =>
      index === 0 ? 0 : calculateHeight(12).stringValue,
    boxSizing: 'border-box',
    backgroundColor: themeColor.white,
    fontSize: rem(1.125),
    lineHeight: 1.33,
    letterSpacing: '0.17px',
    color: themeColor.almostblack,
    cursor: 'pointer',
  },
  selected: {
    borderRadius: '2px',
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    border: `2px solid ${theme.palette.primary.main}`,
  },
  badge: {
    color: theme.palette.primary.main,
    display: 'block',
    '& svg': {
      // Because the checkmark is transparent and the border is showing through
      marginTop: 12,
      marginLeft: 12,
      background: 'white',
      borderRadius: '50%',
    },
  },
}));
